import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ObjectRapportDetails } from 'src/app/shared/model/object';

@Component({
  selector: 'app-status-overzicht-view',
  templateUrl: './status-overzicht-view.component.html',
  styleUrls: ['./status-overzicht-view.component.less']
})
export class StatusOverzichtViewComponent implements OnInit{

  public data: any;
  public currentDate = new Date();
  public object: ObjectRapportDetails = null;

  @Input() KlantAfkorting: string = "";
  @Input() start :Date ;
  @Input() end :Date ;

  constructor(private objectService: ObjectenService) {

  }


  ngOnInit(): void {
    // this.objectService.getObjectRelatieStatusList('MEDNED',new Date(2022,0),new Date(2023,0)).subscribe(data => {
    //   this.data = data;
    // })
  }

  formatNumber(data: any): string {
    return Number(data).toLocaleString("nl-NL", {minimumFractionDigits: 2})
  }

  getTotaal()  {
    let totaal = 0;
    if (!this.data) return ""
    this.data.forEach(element => {
      totaal = totaal + (element.KostenEuro * 1)
    });
    return this.formatNumber(totaal);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (this.start == null || this.end == null || this.KlantAfkorting == "") return; 
    this.objectService.getObjectRelatieStatusList(this.KlantAfkorting,
      this.start,this.end).subscribe(data => {
      if (data.length == 0) return;
      this.data = data;
      let objectid = data[0].ID;
      this.objectService.getStatusRapportObjectDetails(objectid).subscribe(obj => {
        this.object = obj;
      })      
    })
}

  print() {
    window.print();
  }


}
